import { render } from "./HeaderV2.vue?vue&type=template&id=6fc5f786&scoped=true"
import script from "./HeaderV2.vue?vue&type=script&lang=js"
export * from "./HeaderV2.vue?vue&type=script&lang=js"

import "./HeaderV2.vue?vue&type=style&index=0&id=6fc5f786&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc5f786"]])

export default __exports__